// extracted by mini-css-extract-plugin
export default {"customer_filterPanel":"customers_customer_filterPanel__66Gg8","customer_filterPanel_collumnSelect":"customers_customer_filterPanel_collumnSelect__RYC2m"};